<div class="row" id="coumentsContainer">
  <div class="col-xs-12 col-md-4">
    <div class="background2" style="padding: 20px">
      <div class="footer-default medium text-bold">
        {{ userInfo.fullName }}
      </div>
      <br />
      {{ plan.Note }}
      <br />
      <br />
      {{ plan.Document }}
    </div>

    <div style="margin-top: 20px" *ngIf="!plan.acceptedPlan">
      <div
        class="bigYellowButton"
        (click)="accept()"
        [ngClass]="{
          disabled:
            !plan.termsConditions || !plan.myLtiForm || !plan.vexatiousClauses
        }"
      >
        {{ 'PARTECIPANT_LTI.DOCUMENTS.ACCEPT_PLAN' | translate | uppercase }}
      </div>
    </div>

    <div class="row" style="margin-top: 20px" *ngIf="plan.acceptedPlan">
      <div class="col-xs-12">
        <div class="background2" style="padding: 10px; max-width: 550px">
          <div class="big text-bold">
            {{ 'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES' | translate }}
          </div>
          <div class="pointer">
            <textarea
              class="form-control"
              name="name"
              rows="4"
              [ngModel]="plan.Clauses"
              readonly
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-md-8" *ngIf="plan.acceptedPlan">
    <div class="background2" style="padding: 10px; max-width: 200px">
      <div class="big text-bold">
        {{ 'PARTECIPANT_LTI.DOCUMENTS.MY_LTI_FORMS' | translate }}
      </div>
      <div class="pointer" (click)="openPdf('./assets/pdf/MyLTIForm.pdf')">
        <i class="fa fa-file-pdf-o fa-3x"></i>
        <br />
      </div>
    </div>

    <div
      class="background2"
      style="margin-top: 20px; padding: 10px; max-width: 200px"
    >
      <div class="big text-bold">
        {{ 'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS' | translate }}
      </div>
      <div class="pointer" (click)="openPdf(plan.Attachment)">
        <i class="fa fa-file-pdf-o fa-3x"></i>
        <br />
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-md-8" *ngIf="!plan.acceptedPlan">
    <div class="display-flex-left">
      <div class="background2" style="padding: 10px; width: 250px">
        <div class="big text-bold">
          {{ 'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS' | translate }}
        </div>
        <div class="pointer">
          <pdf-viewer
            (click)="openPdf(plan.Attachment)"
            [src]="coreService.getImageURL(plan.Attachment, undefined)"
            [show-all]="false"
            [autoresize]="true"
            [original-size]="false"
            style="margin: 10px auto; height: 28rem; display: block"
          ></pdf-viewer>
        </div>
        <div class="" style="padding: 10px">
          <div class="form-check">
            <input
              class="form-check-input magic-checkbox"
              [(ngModel)]="plan.termsConditions"
              type="checkbox"
              id="termsConditions"
            />
            <label class="form-check-label" for="termsConditions">
              {{
                'PARTECIPANT_LTI.DOCUMENTS.ACCEPT_TERMS_CONDITIONS' | translate
              }}
            </label>
          </div>
        </div>
      </div>

      <div
        class="background2"
        style="padding: 10px; width: 250px; margin-left: 1rem"
      >
        <div class="big text-bold">
          {{ 'PARTECIPANT_LTI.DOCUMENTS.MY_LTI_FORMS' | translate }}
        </div>
        <div class="pointer">
          <pdf-viewer
            (click)="openPdf('./assets/pdf/MyLTIForm.pdf')"
            [src]="'./assets/pdf/MyLTIForm.pdf'"
            [show-all]="false"
            [autoresize]="true"
            [original-size]="false"
            style="margin: 10px auto; height: 28rem; display: block"
          ></pdf-viewer>
        </div>
        <div class="" style="padding: 10px">
          <div class="form-check">
            <input
              class="form-check-input magic-checkbox"
              [(ngModel)]="plan.myLtiForm"
              type="checkbox"
              id="myLtiForm"
            />
            <label class="form-check-label" for="myLtiForm">
              {{ 'PARTECIPANT_LTI.DOCUMENTS.ACCEPT_MY_LTI_FORMS' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 20px">
      <div class="col-xs-12">
        <div class="background2" style="padding: 10px; max-width: 550px">
          <div class="big text-bold">
            {{ 'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES' | translate }}
          </div>
          <div class="pointer">
            <textarea
              class="form-control"
              name="name"
              rows="4"
              [ngModel]="plan.Clauses"
              readonly
            ></textarea>
          </div>
          <div class="" style="padding: 10px">
            <div class="form-check">
              <input
                class="form-check-input magic-checkbox"
                [(ngModel)]="plan.vexatiousClauses"
                type="checkbox"
                id="vexatiousClauses"
              />
              <label class="form-check-label" for="vexatiousClauses">
                {{
                  'PARTECIPANT_LTI.DOCUMENTS.ACCEPT_VEXATIOUS_CLAUSES'
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
